import { Outlet }           from "react-router-dom";
import NavBar               from "./NavBar";
import { Box }              from "@mui/material";
import { AvvisiProvider }   from "../context/AvvisiContext";

const Layout = () => {

    return (
        <AvvisiProvider>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <NavBar />
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Outlet />
            </Box>
        </Box>
        </AvvisiProvider>
    );
};

export default Layout;
